import { render, staticRenderFns } from "./docs-per-partner-pie.vue?vue&type=template&id=32455e5a&scoped=true&"
import script from "./docs-per-partner-pie.vue?vue&type=script&lang=js&"
export * from "./docs-per-partner-pie.vue?vue&type=script&lang=js&"
import style0 from "./docs-per-partner-pie.vue?vue&type=style&index=0&id=32455e5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32455e5a",
  null
  
)

export default component.exports